import { MediaFeedType } from '@optools/services/operator-gateway/types/generated/graphql';

export enum VerticalPosition {
  TOP,
  BOTTOM,
}

export function determineNotificationPosition(
  feedType: MediaFeedType,
  vertical: VerticalPosition = VerticalPosition.TOP,
) {
  if (feedType === MediaFeedType.AWAY) {
    return vertical === VerticalPosition.TOP ? 'top-left' : 'bottom-left';
  } else {
    return vertical === VerticalPosition.TOP ? 'top-right' : 'bottom-right';
  }
}
